import * as React from 'react';
import { __ } from '../../../../helpers/TranslationService';
import { TextCollapsible } from '../../../../components/TextCollapsible/TextCollapsible';
import styled from '@emotion/styled';
import { memo } from 'react';
import { CruisePageSectionHeader } from '../../components/SectionHeader/SectionHeader';

interface IProps {
    includedServices: string;
    notesAndHints: string[];
    optionalServices: string;
    excludedServices: string;
    isOpen?: boolean;
}

const styles: Record<string, React.CSSProperties> = {
    wrapper: {
        overflow: 'hidden',
    },
    title: {
        margin: '10px 0',
    },
};

interface IService {
    title: string;
    html: string;
}

const Service = (props: IService) => {
    if (props.html) {
        return (
            <div>
                <div className="inclusives-title" style={styles.title}>
                    {props.title}
                </div>
                <div className="inclusives-text" dangerouslySetInnerHTML={{ __html: props.html }} />
            </div>
        );
    }
    return null;
};

const NotesAndHints = ({ html }: { html: string[] }) => {
    if (html && html.length > 0) {
        const NotesAndHintsText = html.map((item, index) => (
            <div
                key={`notes-and-hints:${index}`}
                className="inclusives-text"
                dangerouslySetInnerHTML={{ __html: item }}
            />
        ));
        return (
            <div>
                <div className="inclusives-title" style={styles.title}>{`${__(
                    'Hint:',
                    'dreamlines',
                )}`}</div>
                {NotesAndHintsText}
            </div>
        );
    }
    return null;
};

const InclusivesDesktopWrapper = styled.div`
    max-width: 1150px;
    margin: 0 auto;
`;

export function InclusivesText(props: IProps) {
    const stylesOverride = props.isOpen !== false ? { height: 'auto' } : { height: '120px' };
    return (
        <div style={{ ...styles.wrapper, ...stylesOverride }}>
            <Service
                title={`${__('services included', 'dreamlines')}:`}
                html={props.includedServices}
            />
            <Service
                title={`${__('The following services are excluded in the price:', 'dreamlines')}`}
                html={props.excludedServices}
            />
            <Service
                title={`${__('Optional bookable services:', 'dreamlines')}`}
                html={props.optionalServices}
            />
            <NotesAndHints html={props.notesAndHints} />
        </div>
    );
}

const InclusivesDesktop = ({
    includedServices,
    optionalServices,
    excludedServices,
    notesAndHints,
}: IProps) => {
    const [isOpen, toogleState] = React.useState(false);

    const toogleStateOpen = (isOpen) => {
        toogleState(isOpen);
    };

    const hasServicesData = Boolean(
        includedServices || optionalServices || excludedServices || notesAndHints.length,
    );

    if (!hasServicesData) {
        return null;
    }

    return (
        <InclusivesDesktopWrapper>
            <CruisePageSectionHeader>{__('Services', 'dreamlines')}</CruisePageSectionHeader>
            <div className="cruisePageSectionContainer inclusive-container">
                <InclusivesText
                    includedServices={includedServices}
                    optionalServices={optionalServices}
                    excludedServices={excludedServices}
                    notesAndHints={notesAndHints}
                    isOpen={isOpen}
                />
                <TextCollapsible isOpen={isOpen} toogleStateOpen={toogleStateOpen} />
            </div>
        </InclusivesDesktopWrapper>
    );
};
export default memo(InclusivesDesktop);
